import { useAtomValue } from 'jotai';
import { usePathname } from 'next/navigation';

import { Typography } from '@gds/Typography/Typography';
import { checkoutDataFieldValueAtom } from '@util-commerce/Atoms/Checkout/CheckoutDataFieldValue.atom';

import type { CalculatorMessages } from '../FinancingCalculator/Calculator.messages';

import styles from './Header.module.css';

type Props = {
  strings: CalculatorMessages;
  handleHelpDialog?: () => void;
};

export const Header = ({ strings, handleHelpDialog }: Props) => {
  const pathname = usePathname();
  const showDynamic = pathname.includes('/finance-deal');
  const paymentMethod = useAtomValue(checkoutDataFieldValueAtom('paymentMethod'));
  const showPrivateLeasingHeader = paymentMethod === 'privateLeasing';
  const showThreeWayFinancingHeader = paymentMethod === 'threeWayFinancing';

  return (
    <header className={styles.headerContainer}>
      <div className={styles.header}>
        {!showDynamic && <Typography variant="h4">{strings.wantToPayMonthly}</Typography>}
        {showDynamic && (
          <Typography variant="h4">
            {showPrivateLeasingHeader && strings.privateLeasingFinance}
            {showThreeWayFinancingHeader && strings.threeWayFinance}
          </Typography>
        )}

        <div className={styles.content}>
          <Typography variant="body4" Component="p">
            {strings.introHeader}
          </Typography>

          <Typography variant="buttonLink3" onClick={handleHelpDialog} className={styles.findOut}>
            {strings.findOut}
          </Typography>
        </div>
      </div>
    </header>
  );
};
